import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { FormlyModule } from '@ngx-formly/core';
import { AlertModule } from 'app/components/alert/alert.module';
import { DataListModule } from '../data-list/data-list.module';
import { OutstandingLoansSmartComponent } from './outstanding-loans-smart.component';
import { OutstandingLoansFieldGroupWrapperComponent } from './outstanding-loans.wrapper';

@NgModule({
    declarations: [
        OutstandingLoansSmartComponent,
        OutstandingLoansFieldGroupWrapperComponent
    ],
    imports: [
        CommonModule,
        DataListModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        AlertModule,
        FormlyModule.forChild({
            wrappers: [
                { name: 'outstanding-loans-field-group-wrapper', component: OutstandingLoansFieldGroupWrapperComponent }
            ]
        })
    ],
    exports: [
        OutstandingLoansSmartComponent
    ],
    providers: []
})
export class OustandingLoansModule {}
